import React from "react";
import PropTypes from "prop-types";

/**
 * Komponent pojedynczego taba
 * 
 * @param {number} index Określa index taba - na jego podstawie jest okreslany aktywny tab
 * @param {string} name Określa nazwę wyświetlaną na tabie
 * @param {boolean} isActive Określa czy tab jest aktywny
 * @param {function} onClick Funkcja wywoływana na klik taba
 */
const Tab = ({ index, name, isActive, onClick }) => (
  <button className={`w3-button w3-quarter tablink w3-bottombar w3-hover-light-grey w3-padding ${isActive ? 'w3-border-theme' : ''}`} onClick={(event) => onClick(index)}>
    {name}
  </button>
);

Tab.propTypes = {
  /**
   * Określa index taba - na jego podstawie jest okreslany aktywny tab. Nie jest wymagany, poniewaz nadawany jest automatycznie w komponencie opakowującym Tabs
   */
  index: PropTypes.number,
  /**
   * Określa nazwę wyświetlaną na tabie
   */
  name: PropTypes.string.isRequired,
  /**
   * Określa czy tab jest aktywny. Nie jest wymagany, poniewaz nadawany jest automatycznie w komponencie opakowującym Tabs
   */
  isActive: PropTypes.bool,
  /**
   * Funkcja wywoływana na klik taba. Nie jest wymagana, poniewaz nadawany jest automatycznie w komponencie opakowującym Tabs
   */
  onClick: PropTypes.func
};

export default Tab;
